import { render, staticRenderFns } from "./demo_list.vue?vue&type=template&id=6f4be1e8"
import script from "./demo_list.vue?vue&type=script&lang=js"
export * from "./demo_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("G:\\pinmingproject\\suppervision-manager-ui-huangshi\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6f4be1e8')) {
      api.createRecord('6f4be1e8', component.options)
    } else {
      api.reload('6f4be1e8', component.options)
    }
    module.hot.accept("./demo_list.vue?vue&type=template&id=6f4be1e8", function () {
      api.rerender('6f4be1e8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/demo_list.vue"
export default component.exports